import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';
import { LabDip } from '../../models/lab-dip/lab-dip';
import { LabDipCreateRecipe } from '../../models/lab-dip/lab-dip-create-recipe';
import { LabDipSearch } from '../../models/commands/lab-dip-search';
import { LabDipListSearch, LabDipListResponse } from '../../models/commands/lab-dip-list-search';

@Injectable({
  providedIn: 'root',
})
export class LabDipProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/lab-dip';

  public getLabDips(): Observable<ApiResponse<LabDip[]>> {
    return this.httpClient.get<ApiResponse<LabDip[]>>(`${this.baseUrl}/all`);
  }

  public getLabDipById(id: string): Observable<ApiResponse<LabDip>> {
    return this.httpClient.get<ApiResponse<LabDip>>(`${this.baseUrl}/${id}`);
  }

  public searchLabDips(searchCommand: LabDipSearch): Observable<ApiResponse<PaginatedApiResponse<LabDip>>> {
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<LabDip>>>(`${this.baseUrl}/search`, searchCommand);
  }

  public search(
    searchCommand: LabDipSearch,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder?: number,
  ): Observable<ApiResponse<PaginatedApiResponse<LabDip>>> {
    let url = `${this.baseUrl}/search?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (sortField) {
      url += `&sortField=${sortField}&sortOrder=${sortOrder ?? -1}`;
    }
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<LabDip>>>(url, searchCommand);
  }

  public upsertLabDip(labDip: LabDip): Observable<ApiResponse<LabDip>> {
    return this.httpClient.post<ApiResponse<LabDip>>(`${this.baseUrl}`, labDip);
  }

  public searchListLabDip(searchCommand: LabDipListSearch): Observable<ApiResponse<LabDipListResponse>> {
    return this.httpClient.post<ApiResponse<LabDipListResponse>>(`${this.baseUrl}/search-list-labdip`, searchCommand);
  }

  public createRecipe(request: LabDipCreateRecipe): Observable<ApiResponse<LabDip>> {
    return this.httpClient.post<ApiResponse<LabDip>>(`${this.baseUrl}/create-recipe`, request);
  }
}
